import React from 'react';
import { deleteJson } from '../helpers/RequestsHelper';
import ActiveExecutionsContinue from './ActiveExecutionsContinue';
import ActiveExecutionsForm from './ActiveExecutionsForm'

const ActiveExecutions = (props) => {

  const items = props.items


  return (
    items ?
      <> <br />
        <div className="apps-group" key={items.map(a => a.id).join("_")}>
          <p className="apps-group-title">Active executions</p>
          {items.map(item => {
            const block = props.workflow.blocks.find(a => a.id === item.blockId)
            return block ?
              <div key={item._id}>
                {block.action.id === "continue" ?
                  <ActiveExecutionsContinue item={item} block={block} onUpdate={props.onUpdate} />
                  :
                  <ActiveExecutionsForm item={item} block={block} onUpdate={props.onUpdate} />
                }
              </div>
              : "Block" + JSON.stringify(item)
          }
          )}
        </div>
      </>
      : ""
  )
}

export default ActiveExecutions